module.exports = __webpack_public_path__ + "media/images/advisor/img_5_3-20b5cdef3b3eaa8fb7ff617770d28178.png";